import React from 'react'

import {Controller, useFormContext} from '../../externalPackage'
import {MultiSwitchRequirementModel, MultiSwitchValue} from '../types'
import {MultiSwitchRequirementItem} from './MultiSwitchRequirementItem/MultiSwitchRequirementItem'

type Props = {
  name: string
  requirement: MultiSwitchRequirementModel
  onChange?: (value?: MultiSwitchValue[]) => void
}

export function MultiSwitchRequirement({requirement, name, onChange}: Props): React.ReactElement {
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue={requirement.defaultValue}
      name={name}
      render={({field}) => (
        <React.Fragment>
          {requirement.options.map(option => {
            const selectedValues = field.value ?? []
            const isChecked = selectedValues.includes(option.value)

            const changeHandler = () => {
              const newValues = isChecked
                ? selectedValues.filter((value: MultiSwitchValue) => value !== option.value)
                : [...selectedValues, option.value]

              field.onChange(newValues)
              onChange?.(newValues)
            }

            return (
              <MultiSwitchRequirementItem
                key={option.value}
                isChecked={isChecked}
                name={name}
                onChange={changeHandler}
                option={option}
              />
            )
          })}
        </React.Fragment>
      )}
      rules={{
        required: requirement.required,
      }}
    />
  )
}
